import styled, { css } from 'styled-components'

import { widgetPreviewViews } from '../constants'

const viewStyles = {
  [widgetPreviewViews.popup]: css`
    width: 100%;
    max-width: calc(${props => props.theme.primitives.size.sizing40} * 9);
    box-shadow: ${props => props.theme.elevation.elevation2};
  `,
  [widgetPreviewViews.full]: css`
    width: 100%;
    max-width: calc(${props => props.theme.primitives.size.sizing40} * 11);
    height: calc(${props => props.theme.primitives.size.sizing64} * 10);
  `,
}

export const Container = styled.div`
  justify-self: center;
  ${props => viewStyles[props.view]}
`
